import React from 'react';
import { FormattedMessage } from 'react-intl';

import { trpc } from '../../api/trpc';
import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';
import { FormattedValue } from '../../store/formatted-value';
import { ControlBox } from '../../atoms/control-box';
import { ButtonBox } from '../../molecules/button-box';
import { ParentPaper } from '../../atoms/parent-paper';

const DevSubscriptions = () => {
  const [serviceActive, premium] = useSelector(
    ({ variables: { SERVICE_ACTIVE, PREMIUM } }) =>
      [SERVICE_ACTIVE, PREMIUM] as const
  );

  const { mutate: fetchSubscriptions } =
    trpc.subscriptions.triggerFetch.useMutation();

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="dev_homepage.title"
            defaultMessage="Vývojové menu"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <Group
      layout="list"
      title={
        <FormattedMessage
          id="subscriptions.title"
          defaultMessage="Předplatné"
        />
      }
    >
      <ParentPaper>
        <ControlBox
          title={
            <FormattedMessage
              id="subscriptions.last_fetch_at"
              defaultMessage="Poslední aktualizace"
            />
          }
          fullWidth
          subtitle={<FormattedValue variableId="SUBSCRIPTIONS_LAST_CHECK_AT" />}
        />
        <ButtonBox
          title={
            <FormattedMessage
              id="subscriptions.fetch"
              defaultMessage="Aktualizovat předplatné"
            />
          }
          buttonLabel={
            <FormattedMessage
              id="subscriptions.fetch.button"
              defaultMessage="Aktualizovat předplatné"
            />
          }
          onClick={() => fetchSubscriptions()}
          fullWidth
        />
        <ControlBox
          title={
            <FormattedMessage
              id="subscriptions.premium_active"
              defaultMessage="Premium aktivní"
            />
          }
          fullWidth
          subtitle={premium ? 'Ano' : 'Ne'}
        />
      </ParentPaper>
    </Group>
  );
};

export default DevSubscriptions;
